import React from "react";
import { Link } from "react-router-dom";
const getBenefitColumns = (deleteFunc) => {
  return [
    {
      title: "S.No",
      dataIndex: "id",
      render: (text, record, index) => index + 1,
      sorter: (a, b) => a.id.length - b.id.length,
      width: "10%",
    },
    {
      title: "Title",
      dataIndex: "name",
      width: "25%",
    },
    {
      title: "Image",
      render: (text, record) => <img src={record.image} />,
      width: "25%",
    },
    {
      title: "Description",
      dataIndex: "discription",
      width: "25%",
    },
    {
      title: "Action",
      className: "text-end",
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item" to={`/addbenefits/${record.id}`}>
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link>
            {/* <button
              className='dropdown-item'
              onClick={{}}
            >
              <i className='fa fa-trash m-r-5' /> Delete
            </button> */}
          </div>
        </div>
      ),
      width: "15%",
    },
  ];
};

export default getBenefitColumns;
